var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--referral_refer-now-referral new-container mx-auto"
  }, [_c('div', {
    staticClass: "tw-container tw-mx-auto"
  }, [_c('div', {
    staticClass: "get-in-touch tw-relative tw-shadow tw-rounded-lg tw-h-[408px]"
  }, [_c('div', {
    staticClass: "tw-w-full tw-h-full tw-absolute tw-left-0 tw-top-0 tw-rounded-lg tw-z-10 tw-overflow-hidden"
  }, [_c('nuxt-img', {
    staticClass: "tw-h-full tw-object-contain tw-centered-xy",
    attrs: {
      "src": "/assets/images/referral/refer-now-referral.svg",
      "width": "1110",
      "height": "408",
      "alt": "refer-now-referral",
      "loading": "lazy"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-relative tw-z-20 tw-h-full tw-w-full tw-flex tw-justify-center tw-items-center tw-px-7.5"
  }, [_c('div', {
    staticClass: "tw-flex tw-flex-col tw-justify-center tw-items-center"
  }, [_c('h2', {
    staticClass: "tw-text-27 tw-font-semibold tw-mb-0 tw-text-center tw-tracking-tightest3x"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('components.refer.now.referral.title')) + "\n          ")]), _vm._v(" "), _c('nuxt-link', {
    staticClass: "tw-text-11px tw-font-semibold tw-tracking-wide !tw-no-underline tw-text-center tw-bg-white hover:tw-bg-zinc-100 tw-text-primary hover:tw-text-primary tw-rounded tw-shadow tw-mt-5 tw-px-7.5 tw-py-[16.5px] tw-w-full",
    attrs: {
      "to": _vm.localePath(_vm.link)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('components.referral.refer-now-button-title')) + "\n          ")])], 1)])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }